import { useState } from "react";
import { useMemoizedFn } from "ahooks";

export default function useModalCanBeSeen() {
  const [id] = useState(`pin-editor-${Date.now()}`);

  const setCanBeSeen = useMemoizedFn((canBeSeen) => {
    let element = document.querySelector(`.${id}`);
    while (!element.className.includes("ant-modal-root")) {
      element = element.parentElement;
    }
    element.style.opacity = canBeSeen ? 1 : 0;
  });
  return { id, setCanBeSeen };
}
